/**
 * humanCheckApi.ts — server-side Turnstile token verification.
 */

const BASE = '/newspaper/api/v1'

/**
 * POST /auth/verify-human/
 * Sends the Cloudflare Turnstile token to Django for server-side validation.
 * Resolves on success (HTTP 200), throws on failure.
 */
export async function verifyHuman(turnstileToken: string): Promise<void> {
  const res = await fetch(`${BASE}/auth/verify-human/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: turnstileToken }),
  })
  if (!res.ok) {
    let message = 'Verification failed. Please try again.'
    try {
      const data = await res.json() as { error?: string }
      if (data.error) message = data.error
    } catch {
      // ignore parse errors
    }
    throw new Error(message)
  }
}
